import { render } from "./messageNotice.vue?vue&type=template&id=54a0f22d&scoped=true"
import script from "./messageNotice.vue?vue&type=script&lang=js"
export * from "./messageNotice.vue?vue&type=script&lang=js"

import "./messageNotice.vue?vue&type=style&index=0&id=54a0f22d&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Ejzw/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a0f22d"]])

export default __exports__